module.exports = __webpack_public_path__ + "img/sber_0028.7dde64d5.png";